if($('.type-category').length){
    function customCategory(){
        if($('.subcategories').length){
            console.log()
            $('a .image img').each(function(){
                $(this).attr('data-src', $(this).attr('data-src').replace('/thumb/', '/orig/'))
            })
            if(!$('.noParametricSubcategories').length){
                $('.category-top').after('<ul class="noParametricSubcategories"></ul>')
            }
           
            $('.noParametricSubcategories').append($('.subcategories li:not(.parametric)'))
            $('.subcategories').attr('data-length', $('.subcategories>li').length)
            
        }
        if($('.category-perex p[style="text-align: justify;"]').length>0){
            $('.category-top').addClass('haveImage').prepend('<div class="absoluteImage"></div>')
            $('.absoluteImage').append($('.category-perex p[style="text-align: justify;"]'))
        }

        if(!$('.category-header .filters-unveil-button-wrapper').length){
            $('.filters-unveil-button-wrapper').clone().appendTo('.category-header')
        }
        if(!$('#filters-wrapper #filters .close').length){
            $('#filters-wrapper #filters').prepend('<span class="close"></span>')
        }
       
    }
    $(document).ready(function(){
        customCategory();
        customBannersCategory();
    })
    document.addEventListener('ShoptetDOMContentLoaded', function () {
        customCategory();
        customBannersCategory();
    });
    $('html').on('click', '.filters .close', function(){
        $(this).closest('.visible').removeClass('visible');
        $('body').removeClass('filters-visible');
        $('[data-unveil="filters"]').attr('data-text', 'Zavřít filtr').text('Otevřít filtr')

    })

    $(document).ready(function () {
        if(sessionStorage.categoryBanners) {
          $('.CategoryImport').append(sessionStorage.categoryBanners);
        } else {
          $.ajax({
                type: "GET",
                dataType: "html",
                timeout: 1e4,
                cache: !0,
                url: "/",
                success: function(e) {
                    var a = shoptet.common.createDocumentFromString(e);
                    var suitUpHtml = $(a).find(".suitUp").closest('span').html();
                    if (suitUpHtml !== null) {
                        $(".CategoryImport").append(suitUpHtml);
                    }
                    
                    sessionStorage.categoryBanners = $(".CategoryImport").html();
                }
          });
        }           
    })

}

